module.exports = __webpack_public_path__ + "img/snow.7a79d4ce.png";